module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-3-12dcd7883ec4441d5ca2be2fd6399de3.png";